/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { StandalonePlatform } from 'embercom/objects/standalone/constants';
import type Transition from '@ember/routing/transition';
import { ReactRoute } from 'embercom/lib/react-route';

class ChannelRoute extends Route {
  @service declare finStandaloneService: FinStandaloneService;

  reactEnabled() {
    let { platform } = this.paramsFor(this.routeName) as { platform: StandalonePlatform };
    return this.finStandaloneService.canStandalonePlatformUseStepBasedIA(platform);
  }

  private platformConfigs: Partial<
    Record<
      StandalonePlatform,
      { isLoading: () => boolean; loadTask: () => ReturnType<typeof taskFor> }
    >
  > = {
    [StandalonePlatform.Freshdesk]: {
      isLoading: () => this.finStandaloneService.isLoadingFreshdeskConfig,
      loadTask: () => taskFor(this.finStandaloneService.loadFreshdeskConfig),
    },
  };

  async beforeModel(transition: Transition) {
    let { platform } = transition.to.params as { platform: StandalonePlatform };
    let config = this.platformConfigs[platform];

    let promises: Promise<void>[] = [this.finStandaloneService.platform.loadRequiredData()];

    if (config && this.finStandaloneService.hasStandalonePlatform(platform)) {
      let task = config.loadTask();
      promises.push(config.isLoading() ? task.lastRunning! : task.perform());
    }

    await Promise.all(promises);
  }
}

export default ReactRoute(ChannelRoute);
